// import axios from "axios";
// const axiosInstance = axios.create({
//   baseURL: `http://54.66.218.182:3003/api/v1/`,
// });
// export default axiosInstance;

import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://api.hotelly.net/api/v1/",
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("hotellySuperAdmin");
    if (token) {
      config.headers["token"] = token;
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("hotellySuperAdmin");
      window.location.replace("/login");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
